import React from 'react'

export const TABS = [
    { label: 'Location Vault', value: 'studio_vault' },
    { label: 'Scouting', value: 'scouting' },
    { label: 'Per Script', value: 'per_script' },
    { label: 'Collections', value: 'collections' },
] as const;

export type TabType =
    | 'studio_vault'
    | 'scouting'
    | 'per_script'
    | 'collections';


const LocationVaultFilterTabs = ({ setActiveTab, activeTab }: { activeTab: TabType, setActiveTab: (value: TabType) => void }) => {

    return (
        <div className="lv-tabs">
            {TABS.map((tab, i) => (
                <button
                    key={tab?.value}
                    className={`lv-tab${activeTab === tab?.value ? ' lv-tab--active' : ''}`}
                    onClick={() => setActiveTab(tab?.value)}
                >
                    {i === 0 && (
                        <img src={activeTab == 'studio_vault' ? '/assets/images/marker.svg' : '/assets/images/studio-inactive.svg'} />
                    )}
                    {i === 1 && (
                        <img src={activeTab == 'scouting' ? '/assets/images/scouting-active.svg' : '/assets/images/scouting-icons.svg'} />
                    )}
                    {i === 2 && (
                        <img src={activeTab == 'per_script' ? '/assets/images/perscript-active.svg' : '/assets/images/perscript.svg'} />
                    )}
                    {i === 3 && (
                        <img src={activeTab == 'collections' ? '/assets/images/collection-active.svg' : '/assets/images/menu-icon/location-vault-active.svg'} />
                    )}
                    {tab?.label}
                </button>
            ))}
        </div>
    )
}

export default LocationVaultFilterTabs